import { useActiveAccount } from '..';

export default function HideFromRoles({ roles, children }) {
  const { hideFromRoles } = useActiveAccount();

  return hideFromRoles(roles) ? null : children;
}
